import * as pdfjs from 'pdfjs-dist';
// @ts-expect-error vite ?url import
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

export { pdfjs };
